
    <table
      mat-table
      [dataSource]="locations"
      cdkDropList
      [cdkDropListData]="locations"
      [cdkDropListDisabled]="!canDrag"
      (cdkDropListDropped)="dropTable($event)"
      class="full-width"
    >
      <ng-container matColumnDef="index">
        <th mat-header-cell *matHeaderCellDef>
          {{ '#' | translate | titlecase }}
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          {{ i + 1 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'name' | translate | titlecase }}
        </th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'status' | translate | titlecase }}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-icon
            svgIcon="map"
            [matTooltip]="element.status"
            [ngClass]="element.status"
          ></mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="preview">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'preview' | translate | titlecase }}
        </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button color="primary" (click)="onPreview(element)">
            <mat-icon svgIcon="view"></mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="navigation">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'navigation' | translate | titlecase }}
        </th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button (click)="onNavigation(element)">
            <mat-icon svgIcon="location"></mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            [disabled]="disableSelect"
            (change)="$event ? masterToggle() : null"
            [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()"
          >
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox
            [disabled]="disableSelect"
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row.id) : null"
            [checked]="selection.isSelected(row.id)"
          >
          </mat-checkbox>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        [ngClass]="{ 'cursor-pointer': canDrag }"
        style="width: 100%"
        *matRowDef="let row; columns: displayedColumns"
        cdkDrag
        cdkDragLockAxis="y"
        [cdkDragData]="row"
      ></tr>
    </table>

    <ml-empty-table
      [data]="locations"
      [loading]="loading"
      [message]="'no-locations'"
    ></ml-empty-table>
  